import './index.scss';
import React from 'react';
import { Iconfont, Tooltip } from '@umu/umu-design';
interface IProps {
    content: string | JSX.Element;
    className?: string;
    placement?: string;
    children?: string | JSX.Element;
}

export const IconTip = (props: IProps) => {
    const { children, content, className = '', placement = 'bottomLeft' } = props;
    return (
        <Tooltip
            color="#fff"
            placement={placement as any}
            title={content}
            autoAdjustOverflow
            overlayClassName={`${className} umu-icon-tip-popover`}
        >
            {children || <Iconfont type="Tips" className="icon-popover-tip" />}
        </Tooltip>
    );
};
